import React from "react"
import { connect, useSelector } from "react-redux"
import { Card, CardBody, Col, ListGroup, ListGroupItem, Row } from "reactstrap"
import { SwitchInputField } from "components/RenderInput"
import { Field, formValueSelector } from "redux-form"
import { FORM_NAMES } from "constants/index"
import { SaveButton } from "components/Buttons"
import { updateClientFeatures } from "store/actions"
import { mapFeaturesSetupToApi } from "../utils"

const LandingScreenTab = ({
  landingScreenFeatures,
  landingScreenSetupValues,
  updateClientFeatures,
  vendorId,
}) => {
  const loggedInVendor = useSelector(state => state.Login.vendorId)
  const handleSave = () => {
    updateClientFeatures({
      id: vendorId,
      values: {
        features: mapFeaturesSetupToApi(
          landingScreenFeatures,
          landingScreenSetupValues
        ),
        type: 0,
      },
      isLoggedInVendor: loggedInVendor == vendorId,
    })
  }

  return (
    <React.Fragment>
      <Row className="my-3">
        <Col>
          <Card>
            <CardBody>
              <ListGroup>
                {landingScreenFeatures.map((feature, index) => {
                  return (
                    <ListGroupItem
                      key={feature.id}
                      className={`py-1 `}
                      style={{ border: "none" }}
                    >
                      <Row>
                        <Col xs={11}>
                          <p className="px-4 pt-3">{feature.name} </p>
                        </Col>
                        <Col xs={1} className={"d-flex justify-content-end"}>
                          <Field
                            name={feature.machine_name}
                            component={SwitchInputField}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            onColor="#2ECC71"
                            offColor="#E74C3C"
                            height={20}
                            width={40}
                            handleDiameter={18}
                          />
                        </Col>
                      </Row>
                    </ListGroupItem>
                  )
                })}
              </ListGroup>
              <Row className="my-3 justify-content-center">
                <Col xl={1}>
                  <SaveButton
                    type="button"
                    content="Save"
                    onClick={handleSave}
                    fullWidth={true}
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.VENDOR_FEATURES)

const mapStateToProps = state => ({
  landingScreenFeatures: state.clients.landingScreenFeatures,
  landingScreenSetupValues: selector(state, "landing_screen_setup"),
})

const mapDispatchToProps = dispatch => ({
  updateClientFeatures: values => dispatch(updateClientFeatures(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(LandingScreenTab)
